import { Link } from 'react-router-dom';
import scssVariables from '../../../../Config.module.scss';
import { DemeterCompanyModel } from '../../../../Generated/Raven-Demeter';
import NavigationRoutes from '../../../../Layouts/NavigationRoutes';
import OverflowCellWithTooltip from '../../../Components/Tables/OverflowCellWithTooltip/OverflowCellWithTooltip';
import { TableDatum, TableHeader } from '../../../Components/Tables/Table/TableDefinitions';
import languageService from '../../../Services/Language/LanguageService';
import { translationKeys } from '../../../Services/Language/TranslationDefinitions';

const fullNameCellRenderer = (parameters: TableDatum<DemeterCompanyModel>) => {
    const { name, demeterCompanyGuid } = parameters;

    return (
        <OverflowCellWithTooltip
            nonTooltipOverrideValue={
                <Link
                    style={{ color: scssVariables.agGridLinkLolor, width: 100 }}
                    to={`${NavigationRoutes.Companies}/${demeterCompanyGuid}/edit?companyTab=companyDetails`}
                >
                    {name}
                </Link>
            }
            value={name}
        />
    );
};

// Column definitions.
export const companyColumnDefinitions = [
    {
        field: 'name',
        headerValueGetter: () => languageService.translate(translationKeys.companies.fields.company),
        minimumWidth: 200,
        cellRenderer: fullNameCellRenderer,
    },
    {
        field: 'billingEmail',
        headerValueGetter: () => languageService.translate(translationKeys.companies.fields.companyAdministrator),
        minimumWidth: 100,
    },
    {
        field: 'createdDate',
        headerValueGetter: () => languageService.translate(translationKeys.companies.fields.dateAdded),
        minimumWidth: 100,
        dataFormat: 'date',
    },
    {
        field: 'numberOfLicenses',
        headerValueGetter: () => languageService.translate(translationKeys.companies.fields.numberOfLicenses),
        minimumWidth: 50,
    },
    {
        field: 'numberOfLicensesUsed',
        headerValueGetter: () => languageService.translate(translationKeys.companies.fields.numberOfLicensesUsed),
        minimumWidth: 50,
    },
    {
        field: 'numberOfUsers',
        headerValueGetter: () => languageService.translate(translationKeys.companies.fields.numberOfUsers),
        minimumWidth: 50,
    },
    {
        field: 'actions',
        headerValueGetter: () => languageService.translate(translationKeys.words.actions),
        width: 150,
        minimumWidth: 150,
        pinned: 'right',
    },
] as TableHeader<DemeterCompanyModel>[];

export const companiesColumnOptions = {
    resizable: true,
    autoHeaderHeight: true,
    wrapHeaderText: true,
    flex: 1,
    rowDragManaged: true,
    animateRows: true,
    wrap: false,
    enableCellChangeFlash: true,
    headerClass: 'ag-header-cell-flex-start',
    sortable: false,
};
